module.exports = "<div class=\"errors-info-container\">\n  <div class=\"error-items\" *ngFor=\"let error of csvErrors\">\n    <span *ngIf=\"error.row\">\n      <span class=\"error-row\">{{ 'CSV_UPLOAD_ERRORS.ROW' | translate }} {{ error.row }}</span>\n      <span class=\"error-message\">{{ error.message }}</span>\n    </span>\n    <span class=\"error-info\" *ngIf=\"!error.row\">\n      {{ error }}\n    </span>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/offers/csv-upload-errors/csv-upload-errors.component.html
// module id = ./src/app/modules/offers/csv-upload-errors/csv-upload-errors.component.html
// module chunks = main